import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" id=\"close\">\n  <polygon fill=\"#4A4A4A\" points=\"8.745 7 14 1.745 12.255 0 7 5.255 1.745 0 0 1.745 5.255 7 0 12.255 1.745 14 7 8.745 12.255 14 14 12.255\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol